import React from 'react';
import './components/MortgageTools.css'; // We'll create this next

const MortgageTools = () => {
  return (
    <div className="container mt-5 mb-5">
      <h2 style={{
    textAlign: "center",
    marginBottom: "3rem",  // Assuming mb-5 = 3rem (Bootstrap scale)
    fontWeight: "bold",
    color: "blue"           // Replace with your specific hex/code if needed
  }}
>🏦 Mortgage Tools</h2>
      <div className="row g-4 justify-content-center">

        {/* Card 1 */}
        <div className="col-12 col-md-6 col-lg-3">
          <div className="card card-animated">
            <img src="/images/FrontPage/calculate.jpg" alt="Loan Calculator" />
            <div className="card-body-animated">
              <h5>EMI Calculator</h5>
              <p>Calculate your monthly payments and total interest costs.</p>
            </div>
            <div className="card-footer-animated">
              <a href="https://app.mortbuzz.in/Mortbuzz-emi-calculater.html" className="btn tool-btn w-100">Use Calculator</a>
            </div>
          </div>
        </div>

        {/* Card 2 */}
        <div className="col-12 col-md-6 col-lg-3">
          <div className="card card-animated">
            <img src="/images/FrontPage/loan-compare-scaled.jpg" alt="Loan Compare" />
            <div className="card-body-animated">
              <h5>Loan Compare</h5>
              <p>Find out best loan options using our comparison tool.</p>
            </div>
            <div className="card-footer-animated">
              <a href="https://app.mortbuzz.in/mortbuzz-home-loan-compare.html" className="btn tool-btn w-100">Compare Loan</a>
            </div>
          </div>
        </div>

        {/* Card 3 */}
        <div className="col-12 col-md-6 col-lg-3">
          <div className="card card-animated">
            <img src="/images/FrontPage/eligibility-scaled.jpg" alt="Check Eligibility" />
            <div className="card-body-animated">
              <h5>Check Eligibility</h5>
              <p>See how much loan amount you are eligible for.</p>
            </div>
            <div className="card-footer-animated">
              <a href="https://app.mortbuzz.in/Mortbuzz-loan-eligibility.html" className="btn tool-btn w-100">Check Now</a>
            </div>
          </div>
        </div>

        {/* Card 4 */}
        <div className="col-12 col-md-6 col-lg-3">
          <div className="card card-animated">
            <img src="/images/FrontPage/car-loan-mustang.png" alt="Balance Transfer" />
            <div className="card-body-animated">
              <h5>Car Loan</h5>
              <p>Our New Service is Live With Low interest Rate Car Loan</p>
            </div>
            <div className="card-footer-animated">
              <a href="https://mortbuzz.in/mortbuzz-solutions-balance-transfer/" className="btn tool-btn w-100">Info</a>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default MortgageTools;
